'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlashMessage = exports.FlashMessageStore = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _ICONS;
// noinspection JSDuplicatedDeclaration


var _FlashMessageStore = require('./FlashMessageStore');

Object.defineProperty(exports, 'FlashMessageStore', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FlashMessageStore).default;
  }
});
Object.defineProperty(exports, 'FlashMessage', {
  enumerable: true,
  get: function get() {
    return _FlashMessageStore.FlashMessage;
  }
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _mobxReact = require('mobx-react');

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _ProgressSpinner = require('../ProgressSpinner');

var _ProgressSpinner2 = _interopRequireDefault(_ProgressSpinner);

var _FlashMessageStore2 = _interopRequireDefault(_FlashMessageStore);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ANIMATION_DURATION = 300;

var ICONS = (_ICONS = {}, (0, _defineProperty3.default)(_ICONS, _FlashMessageStore.FlashMessageTypes.SUCCESS, 'check'), (0, _defineProperty3.default)(_ICONS, _FlashMessageStore.FlashMessageTypes.ERROR, 'exclamation-triangle'), _ICONS);

/**
 * A single item.
 */
var FlashMessageItem = (0, _mobxReact.observer)(function FlashMessageItem(_ref) {
  var flash = _ref.flash;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('FlashMessage', 'FlashMessage--' + flash.type) },
    _react2.default.createElement(
      'div',
      { className: 'FlashMessage__inner' },
      flash.type && ICONS[flash.type] && _react2.default.createElement(
        'div',
        { className: 'FlashMessage__type-container' },
        _react2.default.createElement(_Icon2.default, { name: ICONS[flash.type] })
      ),
      flash.inProgress && _react2.default.createElement(
        'div',
        { className: 'FlashMessage__progress-container' },
        _react2.default.createElement(_ProgressSpinner2.default, null)
      ),
      _react2.default.createElement(
        'div',
        { className: 'FlashMessage__message-content' },
        flash.message
      ),
      _react2.default.createElement(
        'div',
        { className: 'FlashMessage__actions' },
        _react2.default.createElement(
          'button',
          { onClick: function onClick() {
              return flash.dismiss();
            } },
          'Dismiss'
        )
      )
    )
  );
});

/**
 * Flash messages container
 *
 * @param  {FlashMessageStore} options.store
 */
var FlashMessages = function FlashMessages(_ref2) {
  var store = _ref2.store,
      position = _ref2.position;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('FlashMessages', 'FlashMessages--' + position) },
    _react2.default.createElement(
      _reactAddonsCssTransitionGroup2.default,
      {
        transitionName: 'anim',
        transitionEnterTimeout: ANIMATION_DURATION,
        transitionLeaveTimeout: ANIMATION_DURATION
      },
      store.showingFlashes.map(function (f) {
        return _react2.default.createElement(FlashMessageItem, { flash: f, key: f.id });
      })
    )
  );
};

FlashMessages.propTypes = {
  store: _propTypes2.default.instanceOf(_FlashMessageStore2.default),
  position: _propTypes2.default.oneOf(['bottomRight', 'bottomLeft', 'topRight', 'topLeft'])
};

FlashMessages.defaultProps = {
  position: 'bottomRight'
};

exports.default = (0, _mobxReact.observer)(FlashMessages);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/FlashMessages/index.js
// module id = 617
// module chunks = 0